<!-- Pills Section -->
<div class="Notification-pills u-spacing-lg-mb">
    <div class="flex Notification-pills--truncate">
        <ce-pill state="default" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">
            {{ tenantName() }}
        </ce-pill>
    </div>
    <div class="flex flex-end">
        @if (notification().archived) {
            <ce-pill [state]="'default'" icon="archive" ce-pill-xs ce-pill-secondary class="u-spacing-sm-mr">Archived</ce-pill>
        }
    </div>
</div>

<!-- Summary Text -->
<p class="Notification-summary u-text-body-lg">{{ notification().body }}</p>

<!-- Action Button -->
@if (isSubscriptionExpired()) {
    <a
        [href]="detailsInClassicUrl()"
        target="_blank"
        ceTooltip="Opens in MyKempower"
        ce-button
        ce-button-small
        ce-button-type-tertiary
        class="u-spacing-xl-mt u-spacing-2xl-mb"
    >
        {{ linkLabel() }}
        <ce-icon [svgIcon]="'new-tab'" ce-icon-xs suffix-icon />
    </a>
} @else {
    <div class="u-spacing-xl-mt u-spacing-2xl-mb"></div>
}

<!-- Parameter List -->
<ce-parameter-list size="small">
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Subscription number</span>
        <span ceParameterItemValue class="u-text-align-right">{{ licenseNumber() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Organization</span>
        <span ceParameterItemValue class="u-text-align-right">{{ tenantName() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Plan</span>
        <span ceParameterItemValue class="u-text-align-right">{{ licenseName() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Start date</span>
        <span ceParameterItemValue class="u-text-align-right">{{ subscriptionStartDate() }}</span>
    </ce-parameter-item>
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>End date</span>
        <span ceParameterItemValue class="u-text-align-right">{{ subscriptionExpiryDate() }}</span>
    </ce-parameter-item>
    @if (!isSubscriptionExpired()) {
        <ce-parameter-item [orientation]="'horizontal'">
            <span ceParameterLabel>Days remaining</span>
            <span ceParameterItemValue class="u-text-align-right">
                {{ daysUntilExpiration() }} days
            </span>
        </ce-parameter-item>
    }
    <ce-parameter-item [orientation]="'horizontal'">
        <span ceParameterLabel>Email notification</span>
        <span ceParameterItemValue class="u-text-align-right">
            @if (emailTimestamp()?.timestamp) {
                Sent
            } @else {
                Not sent
            }
        </span>
    </ce-parameter-item>
</ce-parameter-list>
